<section>
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">سجل الأن</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">التسجيل</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-become-area bg-color-white rbt-section-gap">
        <div class="container">
            <div class="row pt--60 g-5">
                <div class="col-lg-12">
                    <div class="rbt-contact-form contact-form-style-1 max-width-auto">
                        <div class="section-title text-center">
                            <span class="subtitle bg-primary-opacity">إنضم للمنصة</span>
                        </div>
                        <hr class="mb--30">
                        <form #studentForm="ngForm" id="studentForm" novalidate>
                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="name" id="name" type="text" [(ngModel)]="student.name" required ngModel required #name="ngModel" placeholder="{{'First Name' | translate}}" [maxlength]="150" pattern="[a-zA-z ]*">
                                        <span class="focus-border"></span>
                                    </div>
                                    <small class="d-block mt_dec--5" *ngIf="name.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن لا يحتوي الاسم الاول على أرقام أو حروف خاصة</small>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="surname" id="surname" type="text" [(ngModel)]="student.surname" required ngModel required #surname="ngModel" placeholder="{{'Last Name' | translate}}" [maxlength]="150" pattern="[a-zA-z ]*">
                                        <span class="focus-border"></span>
                                    </div>
                                    <small class="d-block mt_dec--5" *ngIf="surname.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن لا يحتوي اسم العائلة على أرقام أو حروف خاصة</small>
                                </div>
                            </div>

                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="userName" id="userName" type="text" [(ngModel)]="student.userName" required ngModel required #userName="ngModel" placeholder="{{'User name' | translate}}" [maxlength]="50">
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
    
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="mobile" id="mobile" type="text" [(ngModel)]="student.mobile" required ngModel required #mobile="ngModel" placeholder="{{'Phone Number' | translate}}" [maxlength]="10" NumbersOnly>
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="email" id="email" type="text" [(ngModel)]="student.emailAddress" required ngModel required #email="ngModel" placeholder="{{'Email' | translate}}" [email]="true">
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
    
    
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="pass" #input id="pass" type="password" [(ngModel)]="student.pass" required ngModel required #pass="ngModel" placeholder="{{'Password' | translate}}" [maxlength]="20" [minlength]="8">
                                        <span class="focus-border"></span>
                                        <i class="feather-eye" style="position: absolute;left: 3%;top: 29%;cursor: pointer;" (click)="changeInput(input)"></i>
                                    </div>
                                    <small class="d-block mt_dec--5"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن تحتوي كلمة المرور على حرف كبير و صغير و حرف خاص و رقم</small>
                                </div>
                            </div>

                            <br><br>

                            <div class="col-lg-12">
                                <div class="form-submit-group">
                                    <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none w-100" (click)="registerStudent()" [disabled]="!(studentForm.valid && studentForm.dirty)">
                                        <span class="icon-reverse-wrapper">
                                            <span class="btn-text">{{'registerNow' | translate}}</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>